import React, { useState } from "react";
import PropTypes from "prop-types";

import RibbonTag from "../RibbonTag";

import { defaultTextColor } from "../../../Utils/CommonFunctions";

import { useAuth } from "../../../hoc/AuthContext";

// export default function TopDiscountCardDesign({ isMobile, whatsDesign, item, image, mobileViewCardDesign, discountSimilarCard }) {
//   const [showText, setShowText] = useState(false);

//   const handleMouseEnter = () => {
//     setShowText(true);
//   };

//   const handleMouseLeave = () => {
//     setShowText(false);
//   };
//   const getBackgroundImage = () => {
//     const size = whatsDesign && isMobile ? 4 : (mobileViewCardDesign && isMobile ? 6 : 5);
//     const hexCode = item?.brand?.hex_code || "bbb6b6";
//     return `radial-gradient(transparent 0, transparent ${size}px, #${hexCode} ${size}px)`;
//   };

//   const getBackgroundSize = () => {
//     return mobileViewCardDesign && isMobile ? "20px 18px" : "16px 20px";
//   };

//   const getBackgroundPosition = () => {
//     if (isMobile) {
//       return whatsDesign ? "12px 0" : (mobileViewCardDesign ? "12px 4px" : "10px 3px");
//     }
//     return "10px 3px";
//   }

//   const getWidthHeightClass = () => {
//     if (isMobile) {
//       if (whatsDesign) return "w-[87px] h-[60px] mobilecopon";
//       if (mobileViewCardDesign) return "w-[145px] h-[116px] landingDiscount";
//     }
//     return discountSimilarCard ? "w-[180px] h-[126px] similarDiscountCard" : "w-[196px] h-[126px]";
//   };

//   const getImageClass = () => {
//     if (whatsDesign) return isMobile ? "w-16 h-[60px]" : "w-[176px] h-[126px]";
//     if (mobileViewCardDesign) return isMobile ? "w-[128px] h-[116px]" : "w-[176px] h-[126px]";
//     return discountSimilarCard ? "w-40 h-[126px]" : "w-[176px] h-[126px]";
//   };

//   return (
//     <div
//       className={`coupon-item drop-shadow-md relative ${getWidthHeightClass()}`}
//       style={{
//         "--before-background-color": `#${item?.brand?.hex_code}` || "#bbb6b6",
//         backgroundImage: getBackgroundImage(),
//         backgroundSize: getBackgroundSize(),
//         backgroundPosition: getBackgroundPosition(),
//       }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//     >
//       <div className="inline-flex w-full h-full flex-nowrap justify-center items-center">
//         <img
//           src={image}
//           alt={item?.brand?.name}
//           className={`object-contain px-2 ${getImageClass()}`}
//         />
//       </div>
//       {!whatsDesign && <RibbonTag showText={showText} channels={item?.redemption_channel} />}
//     </div>
//   );
// };

export default function TopDiscountCardDesign({ isMobile, whatsDesign, item, image, mobileViewCardDesign, discountSimilarCard }) {
  const [showText, setShowText] = useState(false);

  const { integratorTheme } = useAuth();

  const handleMouseEnter = () => {
    setShowText(true);
  };

  const handleMouseLeave = () => {
    setShowText(false);
  };

  const formatStoreType = (text) => {
    const isOnline = text?.includes("ONLINE");
    const isOffline = text?.includes("OFFLINE");
    if (isOnline && isOffline) return "Online/Offline";
    if (isOnline) return "Online";
    if (isOffline) return "Offline";
    return "";
  };

  return (
    <>
      <div
        className={`relative ${whatsDesign && isMobile ? "w-[87px] h-[60px]" : mobileViewCardDesign && isMobile ? "sm:w-[180px] h-[116px] mobileViewDesign" : "w-[196px] h-[126px]"} drop-shadow-lg`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className={`relative bg-center bg-cover ${whatsDesign && isMobile ? "w-[87px] h-[60px] px-12" : mobileViewCardDesign && isMobile ? "sm:w-[180px] mobileViewDesign h-[116px] px-10" : "w-[196px] h-[126px] px-5"}`}
          style={{
            backgroundImage: `url("${image}")`,
            clipPath: `url(#discountofferDesign)`,
            backgroundColor: `#${item?.brand?.hex_code}`,
            backgroundOrigin: "content-box",
          }}
        ></div>
        <svg className="svg h-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1">
          <clipPath id="discountofferDesign" clipPathUnits="objectBoundingBox">
            <path d="
                      M0,0 
                      V0.06
                      A0.03,0.06 0 0,1 0.035,0.10 
                      A0.03,0.06 0 0,1 0,0.14
                      V0.22
                      A0.03,0.06 0 0,1 0.035,0.26
                      A0.03,0.06 0 0,1 0,0.30
                      V0.38
                      A0.03,0.06 0 0,1 0.035,0.42
                      A0.03,0.06 0 0,1 0,0.46
                      V0.54
                      A0.03,0.06 0 0,1 0.035,0.58
                      A0.03,0.06 0 0,1 0,0.62
                      V0.70
                      A0.03,0.06 0 0,1 0.035,0.74
                      A0.03,0.06 0 0,1 0,0.78
                      V0.86
                      A0.03,0.06 0 0,1 0.035,0.90
                      A0.03,0.06 0 0,1 0,0.94
                      V1 
                      H1 
                      V0.94
                      A0.03,0.06 0 0,1 0.965,0.90
                      A0.03,0.06 0 0,1 1,0.86
                      V0.78
                      A0.03,0.06 0 0,1 0.965,0.74
                      A0.03,0.06 0 0,1 1,0.70
                      V0.62
                      A0.03,0.06 0 0,1 0.965,0.58
                      A0.03,0.06 0 0,1 1,0.54
                      V0.46
                      A0.03,0.06 0 0,1 0.965,0.42
                      A0.03,0.06 0 0,1 1,0.38
                      V0.30
                      A0.03,0.06 0 0,1 0.965,0.26
                      A0.03,0.06 0 0,1 1,0.22
                      V0.14
                      A0.03,0.06 0 0,1 0.965,0.10
                      A0.03,0.06 0 0,1 1,0.06
                      V0 
                      H0
              "></path>
          </clipPath>
        </svg>

        {isMobile && !whatsDesign ? (
          <div style={{ color: defaultTextColor(integratorTheme) }} className="absolute top-1 left-2 text-[10px]">{formatStoreType(item?.redemption_channel)}</div>
        ) : (
          !whatsDesign && <RibbonTag showText={showText} channels={item?.redemption_channel} />
        )}
      </div >
    </>
  );
};

TopDiscountCardDesign.propTypes = {
  item: PropTypes.shape({
    brand: PropTypes.shape({
      hex_code: PropTypes.string,
      name: PropTypes.string,
    }),
    redemption_channel: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  mobileViewCardDesign: PropTypes.bool,
  isMobile: PropTypes.bool,
  whatsDesign: PropTypes.bool,
  image: PropTypes.string,
  cashbackSimilarCard: PropTypes.bool,
};